import { SICBO_BET_TYPES } from '@ezugi/constants';

const SINGLE_PREFIX = '70';
const DOUBLE_PREFIX = '50';
const TRIPLE_PREFIX = '40';
const TOTAL_PREFIX = '3';

const { SMALL, BIG, ODD, EVEN } = SICBO_BET_TYPES;

// TODO: remove this once server side is implemented
export const getWinningBets = (diceOne, diceTwo, diceThree) => {
  // SINGLES
  const result = new Set(
    [ diceOne, diceTwo, diceThree ].map((dice) => `${SINGLE_PREFIX}${dice}`)
  );

  // TRIPLES
  const isTriple = diceOne === diceTwo && diceOne === diceThree;
  if (isTriple) {
    result.add(`${TRIPLE_PREFIX}${diceOne}`);
    result.add(`${TRIPLE_PREFIX}0`);
  }

  // DOUBLES
  if (diceOne === diceTwo || diceOne === diceThree) {
    result.add(`${DOUBLE_PREFIX}${diceOne}`);
  }

  if (diceTwo === diceThree) {
    result.add(`${DOUBLE_PREFIX}${diceTwo}`);
  }

  // COMBINATIONS
  let combo = Number(`${diceOne}${diceTwo}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);
  combo = Number(`${diceTwo}${diceOne}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);
  combo = Number(`${diceOne}${diceThree}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);
  combo = Number(`${diceThree}${diceOne}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);
  combo = Number(`${diceTwo}${diceThree}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);
  combo = Number(`${diceThree}${diceTwo}`);

  if (
    (combo >= 12 && combo <= 16)
    || (combo >= 23 && combo <= 26)
    || (combo >= 34 && combo <= 36)
    || (combo >= 45 && combo <= 46)
    || combo === 56
  ) result.add(600 + combo);

  // TOTALS
  const total = diceOne + diceTwo + diceThree;
  if (total > 3 && total < 18) {
    result.add(`${TOTAL_PREFIX}${String(total).padStart(2, 0)}`);
  }

  // SMALL or BIG
  if (!isTriple) {
    result.add(total < 11 ? SMALL : BIG);
  }

  // ODD or EVEN
  if (!isTriple) {
    result.add(total % 2 === 0 ? EVEN : ODD);
  }

  return Array.from(result);
};
